import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AppContextProps {
    tieneGenero: boolean;
    setTieneGenero: React.Dispatch<React.SetStateAction<boolean>>;
    tieneRuralUrbano: boolean;
    setTieneRuralUrbano: React.Dispatch<React.SetStateAction<boolean>>;
    tieneEtnica: boolean;
    setTieneEtnica: React.Dispatch<React.SetStateAction<boolean>>;
    tieneVulnerables: boolean;
    setTieneVulnerables: React.Dispatch<React.SetStateAction<boolean>>;
    tieneGrupoEdad: boolean;
    setTieneGrupoEdad: React.Dispatch<React.SetStateAction<boolean>>;
}

const AppContext = createContext<AppContextProps | undefined>(undefined);

export const AppProvider = ({ children }: { children: ReactNode }) => {
    const [tieneGenero, setTieneGenero] = useState<boolean>(true);
    const [tieneRuralUrbano, setTieneRuralUrbano] = useState<boolean>(true);
    const [tieneEtnica, setTieneEtnica] = useState<boolean>(true);
    const [tieneVulnerables, setTieneVulnerables] = useState<boolean>(true);
    const [tieneGrupoEdad, setTieneGrupoEdad] = useState<boolean>(true);

    return (
        <AppContext.Provider value={{
            tieneGenero, setTieneGenero,
            tieneRuralUrbano, setTieneRuralUrbano,
            tieneEtnica, setTieneEtnica,
            tieneVulnerables, setTieneVulnerables,
            tieneGrupoEdad, setTieneGrupoEdad
         }}>
            {children}
        </AppContext.Provider>
    );
};

export const useAppState = () => {
    const context = useContext(AppContext);
    if (context === undefined) {
        throw new Error('useAppState must be used within an AppProvider');
    }
    return context;
};
